import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgModel } from '@angular/forms';
import { HolidayFormComponent } from '../holiday-form/holiday-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { SessionService } from '../../../Util/Session/session.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
@Component({
  selector: 'app-holiday',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule],
  templateUrl: './holiday.component.html',
  styleUrl: './holiday.component.scss'
})
export class HolidayComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  HolidayData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private modalService: NgbModal,
    private toast: ToastService,
    private sessionService: SessionService,
    private download: DownloadSampleService,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetHoliday();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetHoliday() {
    this.isDisabled = true;
    this.holiday.GetHoliday({ ESS_HolidayMasterID: 0, SelectType: 2 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addHoliday(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(HolidayFormComponent);
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          this.GetHoliday();
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
  
  //Added By Pooja on 10th May 2024 As per discussion with Sakshi 
  handleFileInput(event: any): void {
    this.HolidayData.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueHolidayIds: Set<number> = new Set();
        const holidayNames: Set<string> = new Set();
        this.HolidayData = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          const id = rowData['ESS_HolidayID'];
          let holidayName = rowData['HolidayName'].toString();

          holidayName = holidayName ? holidayName.trim() : '';

          if (id !== 0 && id !== '' && id !== undefined && uniqueHolidayIds.has(id)) {
            this.toast.show({ message: `Duplicate Holiday ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            uniqueHolidayIds.add(id);
          }

          if (holidayName === '' || holidayName === null || holidayName === undefined) {
            this.toast.show({ message: `Holiday name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (holidayNames.has(holidayName)) {
            this.toast.show({ message: `Duplicate HolidayName "${holidayName}" found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            holidayNames.add(holidayName);
          }
          rowData['HolidayName'] = holidayName;
          this.HolidayData.push(rowData);
        }
        this.BulkInsertUpdate(this.HolidayData);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }
  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.HolidayData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const HolidayData = {
      SelectType: 'upload',
      ESS_HolidayInsert: Data,
      UserId: this.User.UserId,
    };
    this.holiday.BulkHolidayInsertUpdate(HolidayData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: 'Holiday Data saved successfully!', type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.GetHoliday();
      },
      error => {
        console.error('Error:', error);
      });
  }
  downloadExcel() {
    this.download.downloadExcel('HolidayMaster');
  }
  exportToExcel() {
    this.isDisabled =  true
    const data = {
      SelectType: 'HolidayExcel',
      Year : ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.HolidayData = data;
        if(this.HolidayData.length > 0 ){
          this.download.exportToExcel(this.HolidayData, "HolidayMaster_data");
          this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
